var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{attrs:{"id":"app"},on:{"contextmenu":function($event){return _vm.hideContext($event)}}},[_c('router-view',{attrs:{"name":"navigation"}}),_c('router-view'),_c('dialog-handler'),_c('dialog-handler-second')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }